<template>
    <div id="applicants-home">
        <compliance-banner class="mb-6 pl-2 pr-2 text-align-left" :showBanner="!SessionLocationRegistered" />
        <LoanDeliveredDetail class="mb-4"></LoanDeliveredDetail>
        <ApplicantLoansSimulator></ApplicantLoansSimulator>
    </div>
</template>

<script>
import LoanDeliveredDetail from './home/LoanDeliveredDetail.vue';
import ApplicantLoansSimulator from './home/ApplicantLoansSimulator.vue';
import ComplianceBanner from '@components/compliance/ComplianceBanner';
export default {
    name: "ApplicantsHome",
    components: {
        LoanDeliveredDetail,
        ApplicantLoansSimulator,
        ComplianceBanner
    },
    props: {
        source: String
    }
}
</script>